import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EditableGridService, SystemApiService } from '@cv-invision/core';

@Injectable({ providedIn: 'root' })
export class AppScopeMapperService extends EditableGridService {

	private readonly BASE_URL = '/utils';
	protected entity: string;

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * Set configuration
	 * @param scope 
	 * @param entity 
	 */
	setConfiguration(entity: string): void
	{
		this.entity = entity;
	}

	/**
	 * PUT - Save the configuration.
	 */
	saveAppScopeConfiguration(config: Array<{scopeId: string, acuityId: string}>): Observable<any> {
		return this.httpClient.put(`${this.systemApiService.api.orders}${this.BASE_URL}/mapper/${this.entity}`, config);
	}

	/**
	 * GET - Return the list of the App Scope property types configuration mappings.
	 */
	getAppScopeConfiguration(): Observable<any> {
		return this.httpClient.get(`${this.systemApiService.api.orders}${this.BASE_URL}/mapper/${this.entity}?includeAppScopeInfo=true`);
	}
}
